import React from 'react'
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import ImgAsset from '../public'

const AppBarComponent = ({
  subtitle = '',
  onLogout,
  onBack,
  phase,
  showBackButton = false,
}) => {
  const theme = useTheme()
  // Use theme breakpoints for clarity
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const colors = { rain: '#324755', sage: '#87BCBF', snow: '#FFFFFF' }

  // Determine the phase text based on the phase flag
  const phaseText =
    phase === 'F'
      ? 'Forecast'
      : phase === 'P'
      ? 'Postcast'
      : phase === 'N'
      ? 'Nowcast'
      : 'Assessment'

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: colors.rain,
        boxShadow: '0 8px 20px rgba(0,0,0,0.4)',
      }}
    >
      <Toolbar sx={{ minHeight: isMobile ? 56 : 64 }}>
        {/* Left Section: TDIS Logo */}
        <Box
          sx={{
            width: '33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <IconButton edge="start" color="inherit" aria-label="TDIS Logo">
            <img
              src={ImgAsset.TDISlogoWhite}
              alt="TDIS Logo"
              style={{
                // Much smaller on mobile
                width: isMobile ? '50px' : '120px',
                height: isMobile ? '20px' : '40px',
              }}
            />
          </IconButton>
        </Box>

        {/* Center Section: Title */}
        <Box
          sx={{
            width: '34%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 1,
          }}
        >
          <Typography
            variant="h6"
            noWrap // truncates text if not enough space
            sx={{
              fontWeight: 700,
              color: colors.snow,
              letterSpacing: '1.5px',
              textTransform: 'uppercase',
              textShadow: '0 3px 15px rgba(0,0,0,0.5)',
              // Slightly smaller font on mobile
              fontSize: isMobile ? '0.8rem' : '1.2rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <span
              style={{
                color: colors.sage,
                fontSize: isMobile ? '1.2em' : '1.5em',
              }}
            >
              D
            </span>
            amage{' '}
            <span
              style={{
                color: colors.sage,
                fontSize: isMobile ? '1.2em' : '1.5em',
              }}
            >
              {phaseText.charAt(0)}
            </span>
            {phaseText.slice(1)}
            {/* Optionally hide the subtitle on mobile if still overlapping */}
            {!isMobile && subtitle && ` - ${subtitle}`}
          </Typography>
        </Box>

        {/* Right Section: Back Button, Logout Button, TAMU Logo */}
        <Box
          sx={{
            width: '33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: isMobile ? 1 : 2,
          }}
        >
          {showBackButton && (
            <Tooltip title="Back to Selection">
              <IconButton
                onClick={onBack}
                sx={{
                  // Smaller icon button on mobile
                  width: isMobile ? 32 : 48,
                  height: isMobile ? 32 : 48,
                  backgroundColor: colors.sage,
                  color: colors.rain,
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    backgroundColor: '#76B2AC',
                    boxShadow: '0 6px 15px rgba(0,0,0,0.3)',
                  },
                }}
              >
                <ArrowBackIcon fontSize={isMobile ? 'small' : 'medium'} />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Logout">
            <IconButton
              onClick={onLogout}
              sx={{
                width: isMobile ? 32 : 48,
                height: isMobile ? 32 : 48,
                backgroundColor: colors.sage,
                color: colors.rain,
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  backgroundColor: '#76B2AC',
                  boxShadow: '0 6px 15px rgba(0,0,0,0.3)',
                },
              }}
            >
              <PowerSettingsNewIcon fontSize={isMobile ? 'small' : 'medium'} />
            </IconButton>
          </Tooltip>

          <IconButton edge="end" color="inherit" aria-label="TAMU Logo">
            <img
              src={ImgAsset.TAMUlogoWhite}
              alt="TAMU Logo"
              style={{
                // Much smaller on mobile
                width: isMobile ? '60px' : '140px',
                height: isMobile ? '25px' : '50px',
              }}
            />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default AppBarComponent
